import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="bg-white border-t border-gray-200 flex flex-col items-center text-gray-500 py-5 px-4">
      <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4 text-sm text-center">
        <Link to="/mentions-legales" className="hover:text-blue-600 transition-colors">
          Mentions légales
        </Link>
        <span className="hidden md:block text-gray-300">|</span>
        <span>
          Développé par{" "}
          <a
            href="https://alf-environnement.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 font-medium transition-colors"
          >
            ALFenvironnement
          </a>
        </span>
      </div>
    </div>
  );
};

export default Footer;